import { render, staticRenderFns } from "./ShipmentPrototypeChargesList.vue?vue&type=template&id=1e173740&scoped=true"
import script from "./ShipmentPrototypeChargesList.vue?vue&type=script&lang=js"
export * from "./ShipmentPrototypeChargesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e173740",
  null
  
)

export default component.exports